<div class="mb-6 flex justify-between">
    @if (currentUser?.hasPermissionStr("ACTIVITY_READ_TEAM")) {
        <div>
            <p-selectButton
                data-testid="dashboard-scope-toggle"
                [allowEmpty]="false"
                (onChange)="toggleUserOrTeam($event.value)"
                [options]="stateOptions"
                [ngModel]="viewState.selectedStateOption"
                [disabled]="!licenseStatePro"
                pTooltip="{{ 'dashboard_teamchart_proFeature' | translate }}"
                [tooltipDisabled]="licenseStatePro"
            />
        </div>
    }

    <div class="fluid dashboard-header">
        <app-date-range-selector
            [userDateFormat]="userDateFormat"
            [firstDayOfWeek]="firstDayOfWeek"
            [licenseStatePro]="licenseStatePro"
            [dateRange]="viewState.dateRange"
            [dateRangeOption]="viewState.dateRangeOption"
            (onDateChanged)="onDateChanged($event)"
        />
    </div>
</div>

@if (dataState == "no-data") {
    <div data-testid="dashboard-empty-state">
        <div class="mb-16 flex justify-center">
            <div class="mt-20">
                <div class="text-center items-center">
                    <div class="mt-1">
                        <img class="inline" src="{{ 'dashboard_nodata_link' | translate }}" width="60%" height="60%" alt="No data" />
                    </div>
                    <div class="mb-16">
                        <h4>{{ "dashboard_nodata_title" | translate }}</h4>
                        <p [innerHTML]="'dashboard_nodata_text1' | translate"></p>
                    </div>

                    <p class="mb-2" style="color: #818181">{{ "dashboard_nodata_text2" | translate }}</p>

                    <div class="mb-8">
                        <a [routerLink]="['/apps']">
                            <img class="inline" src="/assets/images/app-icons.png" alt="App icons" width="35%" height="35%" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if (dataState == "has-data") {
    <div>
        <div class="p-fluid grid grid-cols-12 gap-4">
            <div class="col-span-12 md:col-span-8">
                <div class="t1">
                    <div style="margin-right: 14px" class="card box t2" data-testid="dashboard-total-card">
                        <h5>{{ "dashboard_total" | translate }}</h5>
                        <h2 style="margin-bottom: 0">{{ totalTime | secondsToHoursMinutes }}</h2>
                    </div>
                    <div style="margin-left: 14px" class="card box t2" data-testid="dashboard-top-tile-card">
                        <h5>Top {{ topLayerName }}</h5>
                        <h2 style="margin-bottom: 0">{{ totalTimeName }}</h2>
                    </div>
                </div>
                <div style="margin-top: 28px" class="card box t3" data-testid="dashboard-bar-chart">
                    <p-chart type="bar" [data]="barData" [options]="stackedOptions" height="31vh"></p-chart>
                </div>
            </div>
            <div class="col-span-12 md:col-span-4">
                <div class="card box t4" data-testid="dashboard-pie-chart">
                    <p-chart width="400" height="400" [options]="pieOptions" type="doughnut" [data]="pieData"></p-chart>
                </div>
            </div>
        </div>

        @if (viewState.selectedStateOption === "Me") {
            <div class="card mt-6" data-testid="dashboard-today-table">
                <h5>{{ "dashboard_today" | translate }}</h5>
                <p-table
                    [value]="todayUserData"
                    [paginator]="false"
                    [rows]="100"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [showCurrentPageReport]="true"
                    sortField="durationSeconds"
                    [sortOrder]="-1"
                    currentPageReportTemplate="{{ 'table_pagination_showing' | translate }} {first} {{ 'table_pagination_to' | translate }} {last} {{
                        'table_pagination_of' | translate
                    }} {totalRecords} {{ 'table_pagination_entries' | translate }}"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>
                            <th>{{ "activities_time" | translate }}</th>
                            <th pSortableColumn="layer1">
                                {{ getLayerName(1) }}
                                <p-sortIcon field="layer1"></p-sortIcon>
                            </th>
                            <th pSortableColumn="layer2" *ngIf="layers[1]?.visible === true">
                                {{ getLayerName(2) }}
                                <p-sortIcon field="layer2"></p-sortIcon>
                            </th>
                            <th pSortableColumn="layer3" *ngIf="layers[2]?.visible === true">
                                {{ getLayerName(3) }}
                                <p-sortIcon field="layer3"></p-sortIcon>
                            </th>
                            <th>{{ "activities_note" | translate }}</th>
                            <th pSortableColumn="durationSeconds">
                                {{ "activities_duration" | translate }}
                                <p-sortIcon field="durationSeconds"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-activity>
                        <tr>
                            <td>
                                <div class="center-wrapper">
                                    <div [style.background-color]="activity.color" [style.border]="getBoarder(activity.color)" class="circle"></div>
                                </div>
                            </td>
                            <td>{{ activity.time }}</td>
                            <td>{{ activity.layer1 }}</td>
                            <td *ngIf="layers[1]?.visible === true">{{ activity.layer2 }}</td>
                            <td *ngIf="layers[2]?.visible === true">{{ activity.layer3 }}</td>
                            <td>{{ activity.note }}</td>
                            <td>{{ activity.durationSeconds | secondsToHoursMinutes }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft"> </ng-template>
                    <ng-template pTemplate="paginatorright"> </ng-template>
                </p-table>
            </div>
        }
    </div>
}

<!-- START Dialog: App Download -- is released after finishing onboarding wizard -->
<p-dialog
    header=""
    [(visible)]="displayAppDownloadModal"
    [style]="{ width: '35vw', margin: '50px' }"
    [closable]="true"
    [closeOnEscape]="false"
    [modal]="true"
    [draggable]="false"
    position="bottomright"
    (onHide)="hideAppDownloadDialog()"
>
    <ng-template pTemplate="content">
        <h2 class="mb-4 text-center">{{ "welcome_download_title" | translate }}</h2>
        <p class="mb-6 text-center">{{ "welcome_download_subtitle" | translate }}</p>
        <div class="start-app-image"></div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="w-full flex justify-center mb-6">
            <div>
                <p-button pRipple type="button" (click)="downloadApp()" icon="pi pi-download" label="{{ 'welcome_download_button' | translate }}"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
<!-- END Dialog: App Download -->
